import React, { Component } from 'react';
import { Modal, Radio, Input, Button, Spin, message } from 'antd';
import TableC from '../../basicElement/TableC';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import Text from '../../basicElement/Text';
import format from '../../shared/format';

const { Group: RadioGroup } = Radio;

class ApproveBaBatchTransfer extends Component {
    state = {
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.notice.queryBaHandById, { baHandId: this.relateId })
        .then(res => {
            this.setState({
                record: res.data || {},
                loading: false,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    show = (approval, relateId) => {
        this.approval = approval;
        this.relateId = relateId;
        this.setState({ visible: true }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: {},
            record: {},
            visible: false,
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch(key) {
            case 'status':
                data.reason = undefined;
            default:
                data[key] = value;
        }
        this.setState({ data });
    }

    submit = () => {
        const { data } = this.state;
        const { status, reason } = data;
        if (!status) {
            message.warning('请选择审批结论！');
            return;
        } else if (status === 'BAL_DISAGREE' && !reason) {
            message.warning('请输入不同意原因！');
            return;
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.notice.handlerBaHandById, {
            ...data,
            baHandId: this.relateId,
        })
        .then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const columns = [{
            title: '交接BA',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
            render: (text, record) => {
                const { employeeCode } = record;
                return format('joint', text, employeeCode);
            }
        }, {
            title: '接收BA',
            dataIndex: 'overUserName',
            key: 'overUserName',
            width: 120,
            render: (text, record) => {
                const { overEmployeeCode } = record;
                return format('joint', text, overEmployeeCode);
            }
        }, {
            title: '客户名称',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 240,
        }];
        return columns;
    }
    
    getDataSource = () => {
        const { record } = this.state;
        const { details } = record;
        const dataSource = [];
        (details || []).forEach(item => {
            const { status, detailList } = item;
            if (status === 'AGREE') {
                dataSource.push(...(detailList || []));
            }
        });
        return dataSource;
    }

    getContent = () => {
        const { record, data } = this.state;
        const { status: msgStatus } = record;
        const { status, reason } = data;
        return (
            <div>
                <TableC
                    scrollY={220}
                    data={this.getDataSource()}
                    columns={this.getColumns()}
                    className="baHandOverDetailId"
                />
                {
                    msgStatus === 'NEW' && this.approval &&
                    <ul className="modal-list" style={{ marginTop: 20 }}>
                        <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                            <div className="item-left" style={{ width: '16%', textAlign: 'left' }}><Text asterisk={false} colon={true}>审批结论</Text></div>
                            <div className="item-right" style={{ width: '84%' }}>
                                <RadioGroup onChange={e => this.handleChange(e.target.value, 'status')} value={status}>
                                    <Radio value='BAL_AGREE'>同意</Radio>
                                    <Radio value='BAL_DISAGREE'>不同意</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                        {
                            status === 'BAL_DISAGREE' &&
                            <li className="modal-item">
                                <div className="item-left" style={{ width: '16%' }}>&nbsp;</div>
                                <div className="item-right" style={{ width: '84%' }}>
                                    <Input
                                        maxLength="255"
                                        value={reason}
                                        placeholder="请填写不同意原因"
                                        style={{width: 240}}
                                        onChange={e => this.handleChange(e.target.value, 'reason')}
                                    />
                                </div>
                            </li>
                        }
                    </ul>
                }
                {
                    msgStatus === 'BAL_DISAGREE' &&
                    <ul className="modal-list" style={{ marginTop: 20 }}>
                        <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                            <div className="item-left" style={{ width: '16%', textAlign: 'left' }}><Text colon={true}>不同意原因</Text></div>
                            <div className="item-right" style={{ width: '84%' }}>{record.reason}</div>
                        </li>
                    </ul>
                }
            </div>
        );
    }

    render() {
        const { visible, loading, record } = this.state;
        let title = '审批CSA批量交接';
        const setting = {};
        if (record.status !== 'NEW') {
            title = 'CSA批量交接';
            setting.footer = <Button type="ghost" onClick={this.hide}>关闭</Button>;
        }
        return (
            <Modal
                title={title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="560px"
                {...setting}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default ApproveBaBatchTransfer;


// WEBPACK FOOTER //
// ./src/components/layout/notice/ApproveBaBatchTransfer.js